module.exports = __webpack_public_path__ + "img/alto-adige.4834de49.png";